/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/promo'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import PromoLanding from '@routes/PromoLanding';

export const Route = createFileRoute('/promo')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={PromoLanding} path='/promo' />
  )
});
